import { Injectable } from "@angular/core";
import { io, Socket } from "socket.io-client";
import { version as appVersion } from "../../../../package.json";
import { AppSettings } from "../../../config/config";

function getCookieValue(name: string): string | null {
  const cookie = document.cookie.split(';').find(c => c.trim().startsWith(name + '='));
  return cookie ? cookie.split('=')[1] : null;
}

export interface ChatStudentListItem {
  studentId: string;
  studentName: string;
  surname: string;
  studentImage: string;
  message: string | null;
  fromUserId: string;
  IsRead: 0 | 1;
  timeStamp: string;
  unreadCount: number;
  isTyping: boolean;
  fkChatGroupId: string | null;
}

export interface ChatMessageItem {
  messageId: string | null;
  message: string;
  fromUserId: string;
  timeStamp: string;
  uid: string;
  IsRead: 0 | 1;
}

// Owns the single persistent Socket.IO connection shared by the chat
// student-list screen and conversation screen. One connection is opened per
// visit to the chat feature and torn down on exit — it is not a
// whole-app-session-lifetime connection.
@Injectable({ providedIn: 'root' })
export class StaffChatSocketService {
  private socket: Socket | null = null;

  connect(): Socket {
    if (this.socket) { return this.socket; }
    const authToken = getCookieValue('usertoken') || '';
    this.socket = io(AppSettings.API_ENDPOINT_STAFF_BASE, {
      transportOptions: {
        polling: {
          extraHeaders: {
            authtoken: authToken,
            lang: 'en',
            appversion: appVersion,
            mobileos: 'web',
            'idempotency-key': crypto.randomUUID(),
          },
        },
      },
    });
    return this.socket;
  }

  getSocket(): Socket | null {
    return this.socket;
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
    }
  }
}
